import { Check, Minus } from 'lucide-react';
import styles from './Checkbox.module.css';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    label?: string;
    error?: boolean;
    indeterminate?: boolean;
}

export const Checkbox = ({
    checked = false,
    onChange,
    label,
    error = false,
    indeterminate = false,
    disabled = false,
    className = '',
    ...props
}: CheckboxProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <label className={`${styles.checkboxContainer} ${disabled ? styles.disabled : ''} ${error ? styles.error : ''} ${className}`}>
            <div className={styles.checkboxWrapper}>
                <input
                    type="checkbox"
                    className={styles.checkboxInput}
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                    {...props}
                />
                <div className={`${styles.checkboxCustom} ${indeterminate ? styles.indeterminate : ''}`}>
                    {indeterminate ? (
                        <Minus size={14} className={styles.checkIcon} />
                    ) : checked ? (
                        <Check size={14} className={styles.checkIcon} />
                    ) : null}
                </div>
            </div>
            {label && <span className={styles.checkboxLabel}>{label}</span>}
        </label>
    );
};
